import { Divider, Grid, Stack } from "@mui/material";
import { AddressFields, FormikDigitsField, FormikTextField } from "@shared";
import { FormikProps } from "formik";

import { useTranslation } from "@/translations";

import { CourtDaysEditor } from "../court-days/court-days-editor/CourtDaysEditor";
import { DistrictsMultiSelect } from "../districts-multi-select/DistrictsMultiSelect";
import { CourtFileNumberPrefixLength, CourtFormType, CourtMaxLength, CourtZipCodeLength } from "./CourtForm.types";

interface Props {
  formik: FormikProps<CourtFormType>;
  courtId?: string;
}

export function CourtFormFields({ formik, courtId }: Props) {
  const { t } = useTranslation();

  return (
    <Stack pt={2} gap={3}>
      <Grid container columnSpacing={2} rowSpacing={2}>
        <Grid size={6}>
          <FormikTextField
            formik={formik}
            fieldName="name"
            label={t("settings.courts.form.name")}
            slotProps={{ input: { inputProps: { maxLength: CourtMaxLength.name } } }}
            required
          />
        </Grid>
        <Grid size={3}>
          <FormikTextField
            formik={formik}
            fieldName="shortCode"
            label={t("settings.courts.form.shortCode")}
            slotProps={{ input: { inputProps: { maxLength: CourtMaxLength.shortCode } } }}
            required
          />
        </Grid>
        <Grid size={3}>
          <FormikDigitsField
            formik={formik}
            fieldName="fileNumberPrefix"
            label={t("settings.courts.form.fileNumberPrefix")}
            slotProps={{ input: { inputProps: { maxLength: CourtFileNumberPrefixLength } } }}
            required
          />
        </Grid>

        <AddressFields
          formik={formik}
          streetField="street"
          houseNumberField="houseNumber"
          zipCodeField="zipCode"
          cityField="city"
          countryField="country"
          required={{ zipCode: true }}
          zipCodeMaxLength={CourtZipCodeLength}
        />
      </Grid>

      <DistrictsMultiSelect formik={formik} courtId={courtId} />

      <Divider />

      <CourtDaysEditor formik={formik} />
    </Stack>
  );
}
